import { TooltipProps, Tooltip } from '@mui/material';
import React, { useState } from 'react';

export type VibTooltipProps = TooltipProps & {
  active?: boolean;
  defaultOpen?: boolean;
};

export const VibTooltip = (props: VibTooltipProps) => {
  const { active = true, defaultOpen, ...restProps } = props;

  const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));
  const onOpen = () => {
    setIsOpen(true);
  };
  const onClose = () => {
    setIsOpen(false);
  };

  return !active ? (
    props.children
  ) : (
    <Tooltip
      slotProps={{
        tooltip: { className: 'bg-primary/90' },
      }}
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      open={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      {...restProps}
    >
      <div>{props.children}</div>
    </Tooltip>
  );
};
